import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";
import FilterBox from "./components/FilterBox";
import ProfileLayout from "../global/ProfileLayout";

import { useTypedSelector } from "../../hooks/useTypedSelector";
import { useUIActions } from "../../hooks/useActions";
import { SelectedNftStep } from "./components/SelectedNftStep";
import { BORROWED, CLAIMABLE, IN_INVENTORY } from "../../constants";
import { OwnedAndClaimable } from "./components/OwnedAndClaimable";
import { Borrowed } from "./components/Borrowed";

const ScholarProfile = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { setSnackbar } = useUIActions();

  const [collapsed, setCollapsed] = useState(false);
  const [view, setView] = useState("gallery");
  const [currStatus, setCurrStatus] = useState(IN_INVENTORY);
  const [innerStepper, setInnerStepper] = useState(0);

  const profileNftsFromRedux = useTypedSelector(
    (state) => state.apiReducer.profileNfts
  );

  const claimableNftsFromRedux = useTypedSelector(
    (state) => state.apiReducer.claimableNfts
  );

  const { collectionWiseProfileNfts } = useTypedSelector(
    (state) => state.apiReducer
  );

  const currStatusNfts =
    currStatus === IN_INVENTORY
      ? profileNftsFromRedux
      : currStatus === CLAIMABLE
      ? claimableNftsFromRedux
      : [];

  const [profileNfts, setProfileNfts] = useState([]);

  const [collectionAddress, setCollectionAddress] = useState("");
  const [droppedNfts, setDroppedNfts] = useState([]);
  const [scholarAddress, setScholarAddress] = useState("");
  const [split, setSplit] = useState("");
  const [step, setStep] = useState(0);
  const [operation, setOperation] = useState("bulk-lend");
  const [selectedNft, setSelectedNft] = useState(
    profileNfts.filter((nftP) => nftP.selected)
  );

  const instanceEntity = {
    scholarAddress: "",
    rewardTokenAddress: "",
    split: "",
    droppedNfts: [],
  };

  const instanceGenerator = () => {
    return instanceEntity;
  };

  const [currentInstance, setCurrentInstance] = useState(0);

  const [instances, setInstances] = useState([instanceEntity]);

  const addInstance = () => {
    setInstances([...instances, instanceGenerator()]);
  };

  const updateInstance = (index, payload) => {
    let copy = [...instances];
    copy[index] = {
      ...copy[index],
      ...payload,
    };
    setInstances(copy);
  };

  const removeInstance = (index) => {
    let copy = [...instances];
    copy.splice(index, 1);
    setInstances(copy);
  };

  useEffect(() => {
    if (innerStepper.length > 0 && currStatus === IN_INVENTORY) {
      setProfileNfts(
        currStatusNfts
          .filter((nft) => nft.nftAddress === innerStepper)
          .map((nft) => {
            return { ...nft, selected: false };
          })
      );
    } else if (innerStepper.length === 0 && currStatus === IN_INVENTORY) {
      setProfileNfts([]);
    } else if (currStatus === CLAIMABLE) {
      setProfileNfts(claimableNftsFromRedux);
    }
  }, [innerStepper, currStatus]);

  useEffect(() => {
    setSelectedNft(profileNfts.filter((nft) => nft.selected));
  }, [profileNfts]);

  const setNftStaesOnSelectOnLoan = (
    dataForProfileNfts,
    itemToRemoveFromDroppedNfts
  ) => {
    console.log("inside main", dataForProfileNfts);
    const tempProfileNfts = profileNfts.map((nftP) => {
      if (
        nftP.lendingId === itemToRemoveFromDroppedNfts.lendingId &&
        nftP.tokenId === itemToRemoveFromDroppedNfts.tokenId &&
        nftP.nftAddress === itemToRemoveFromDroppedNfts.nftAddress
      ) {
        return { ...nftP, selected: !nftP.selected };
      } else {
        return nftP;
      }
    });
    const tempSelectedNft = tempProfileNfts.filter((nft) => nft.selected);

    console.log(
      "every condition",
      collectionAddress,
      tempSelectedNft,

      tempSelectedNft.every(
        (nft) => nft.selected && collectionAddress === nft.nftAddress
      )
    );

    if (tempProfileNfts.filter((nft) => nft.selected).length === 0) {
      setProfileNfts(tempProfileNfts);
      setSelectedNft([]);
      setCollectionAddress("");
    }

    if (tempProfileNfts.filter((nft) => nft.selected).length >= 1) {
      setProfileNfts(tempProfileNfts);
      setSelectedNft(tempProfileNfts.filter((nft) => nft.selected));
    }

    setDroppedNfts(
      droppedNfts.filter(
        (nftD) => nftD.tokenId !== itemToRemoveFromDroppedNfts.tokenId
      )
    );
  };

  const setNftStaesOnSelect = (
    dataForProfileNfts,
    itemToRemoveFromDroppedNfts
  ) => {
    console.log("inside main", { dataForProfileNfts, profileNfts });
    const tempProfileNfts = profileNfts.map((nftP) => {
      if (
        nftP.tokenId === itemToRemoveFromDroppedNfts.tokenId &&
        nftP.nftAddress === itemToRemoveFromDroppedNfts.nftAddress
      ) {
        return { ...nftP, selected: !nftP.selected };
      } else {
        return nftP;
      }
    });
    const tempSelectedNft = tempProfileNfts.filter((nft) => nft.selected);

    console.log(
      "every condition",
      tempSelectedNft,

      tempSelectedNft.every(
        (nft) => nft.selected && collectionAddress === nft.nftAddress
      )
    );

    if (tempProfileNfts.filter((nft) => nft.selected).length === 0) {
      setProfileNfts(tempProfileNfts);
      setSelectedNft([]);
      setCollectionAddress("");
    }

    if (tempProfileNfts.filter((nft) => nft.selected).length === 1) {
      setProfileNfts(tempProfileNfts);
      setSelectedNft(tempProfileNfts.filter((nft) => nft.selected));
      setCollectionAddress(
        tempProfileNfts.filter((nft) => nft.selected)[0].nftAddress
      );
    }

    if (
      tempProfileNfts.filter((nft) => nft.selected).length > 1 &&
      tempSelectedNft.every(
        (nft) => nft.selected && collectionAddress === nft.nftAddress
      )
    ) {
      setProfileNfts(tempProfileNfts);
      setSelectedNft(tempProfileNfts.filter((nft) => nft.selected));
      setCollectionAddress(
        tempProfileNfts.filter((nft) => nft.selected)[0].nftAddress
      );
    }

    if (
      tempProfileNfts.filter((nft) => nft.selected).length > 1 &&
      !tempSelectedNft.every(
        (nft) => nft.selected && collectionAddress === nft.nftAddress
      )
    ) {
      setSnackbar({
        open: true,
        severity: "info",
        message: `Cannot select Nfts other than ${
          tempSelectedNft.filter(
            (nft) => nft.selected && collectionAddress === nft.nftAddress
          )[0].contractName
        } collection`,
      });
    }

    setDroppedNfts(
      droppedNfts.filter(
        (nftD) => nftD.tokenId !== itemToRemoveFromDroppedNfts.tokenId
      )
    );
  };

  console.log("bulk params", { selectedNft, split, scholarAddress });

  if (step === 1) {
    return (
      <SelectedNftStep
        selectedNft={profileNfts}
        setSelectedNft={setSelectedNft}
        setProfileNfts={setProfileNfts}
        setStep={setStep}
        operation={operation}
        droppedNfts={droppedNfts}
        setDroppedNfts={setDroppedNfts}
        scholarAddress={scholarAddress}
        setScholarAddress={setScholarAddress}
        split={split}
        setSplit={setSplit}
        currentInstance={currentInstance}
        setCurrentInstance={setCurrentInstance}
        instances={instances}
        addInstance={addInstance}
        updateInstance={updateInstance}
        removeInstance={removeInstance}
        setInstances={setInstances}
      />
    );
  }
  if (step === 0) {
    return (
      <ProfileLayout
        FilterBox={() => (
          <FilterBox collapsed={collapsed} setCollapsed={setCollapsed} />
        )}
        collectionCount={
          currStatus === IN_INVENTORY && innerStepper === 0 ? true : false
        }
        nftCount={
          currStatus === IN_INVENTORY && innerStepper === 0 ? true : false
        }
      >
        {currStatus !== BORROWED ? (
          <OwnedAndClaimable
            profileNfts={profileNfts}
            setProfileNfts={setProfileNfts}
            setNftStaesOnSelect={
              currStatus === IN_INVENTORY
                ? setNftStaesOnSelect
                : currStatus === CLAIMABLE
                ? setNftStaesOnSelectOnLoan
                : setNftStaesOnSelect
            }
            selectedNft={selectedNft}
            setStep={setStep}
            setOperation={setOperation}
            view={view}
            setView={setView}
            currStatus={currStatus}
            setCurrStatus={setCurrStatus}
            collapsed={collapsed}
            innerStepper={innerStepper}
            setInnerStepper={setInnerStepper}
          />
        ) : (
          <Borrowed
            currStatus={currStatus}
            setCurrStatus={setCurrStatus}
            collapsed={collapsed}
          />
        )}
      </ProfileLayout>
    );
  }
};

export default ScholarProfile;
